/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Affiliate_ReferralsInputs */

const en_affiliate_referrals = /** @type {(inputs: Affiliate_ReferralsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referrals`)
};

const es_affiliate_referrals = /** @type {(inputs: Affiliate_ReferralsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referencias`)
};

const fr_affiliate_referrals = /** @type {(inputs: Affiliate_ReferralsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parrainages`)
};

const de_affiliate_referrals = /** @type {(inputs: Affiliate_ReferralsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfehlungen`)
};

const ja_affiliate_referrals = /** @type {(inputs: Affiliate_ReferralsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`紹介数`)
};

const zh_affiliate_referrals = /** @type {(inputs: Affiliate_ReferralsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐人数`)
};

const ar_affiliate_referrals = /** @type {(inputs: Affiliate_ReferralsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإحالات`)
};

const id_affiliate_referrals = /** @type {(inputs: Affiliate_ReferralsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referal`)
};

const it_affiliate_referrals = /** @type {(inputs: Affiliate_ReferralsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviti`)
};

const ru_affiliate_referrals = /** @type {(inputs: Affiliate_ReferralsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рефералы`)
};

const pt_affiliate_referrals = /** @type {(inputs: Affiliate_ReferralsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicações`)
};

const ko_affiliate_referrals = /** @type {(inputs: Affiliate_ReferralsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추천 수`)
};

/**
* | output |
* | --- |
* | "Referrals" |
*
* @param {Affiliate_ReferralsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const affiliate_referrals = /** @type {((inputs?: Affiliate_ReferralsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Affiliate_ReferralsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_affiliate_referrals(inputs)
	if (locale === "es") return es_affiliate_referrals(inputs)
	if (locale === "fr") return fr_affiliate_referrals(inputs)
	if (locale === "de") return de_affiliate_referrals(inputs)
	if (locale === "ja") return ja_affiliate_referrals(inputs)
	if (locale === "zh") return zh_affiliate_referrals(inputs)
	if (locale === "ar") return ar_affiliate_referrals(inputs)
	if (locale === "id") return id_affiliate_referrals(inputs)
	if (locale === "it") return it_affiliate_referrals(inputs)
	if (locale === "ru") return ru_affiliate_referrals(inputs)
	if (locale === "pt") return pt_affiliate_referrals(inputs)
	return ko_affiliate_referrals(inputs)
});